import { BroadcastMonitor } from "@/features/oversight/monitoring";

export default function MonitoringBroadcastPage() {
  return <BroadcastMonitor />;
}
